// Chave da época do botão recolher/expandir: "true" = recolhida. Mantida para
// quem tinha recolhido continuar com a sidebar desafixada.
const STORAGE_KEY = 'fixe-sidebar-collapsed';

/** Fixada = ocupa espaço aberta. Desafixada = trilho que abre por cima no hover. */
export function getSidebarPinned(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'true';
  } catch {
    return true;
  }
}

export function setSidebarPinned(pinned: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(!pinned));
  } catch {
    /* storage indisponível */
  }
}

export const SIDEBAR_WIDTH_EXPANDED = 268;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
